import BaseApi from './BaseApi'

class UserApi extends BaseApi {
  async login (email, password) {
    try {
      const authData = await this.post('user/login', { email, password })
      this.setAuth(authData)
      return authData.user
    } catch (exception) {
      return Promise.reject(exception)
    }
  }

  makeAuth (authObj) {
    this.setAuth(authObj)
  }

  getUser () {
    return this.post('user/authorized')
  }

  updateUser (personalInfo) {
    return this.put('user/profile', personalInfo)
  }

  updateEmail (email) {
    return this.post('user/profile/updateEmail', email)
  }

  updateEmailConfirm (hash) {
    return this.post('user/profile/updateEmailFinish', hash)
  }

  updatePassword (passwordsObj) {
    return this.post('user/profile/updatePassword', passwordsObj)
  }

  resetPassword ({ email, password, password_confirmation, token }) {
    return this.post('user/resetPassword', { email, password, password_confirmation, token })
  }

  forgotPassword (email) {
    return this.post('user/forgotPassword', { email })
  }

  logout () {
    this.post('user/logout')
    this.setAuth(false)
  }

  registrationConfirmation (hash) {
    return this.post('user/verify', { hash })
  }

  updateGdpr (value) {
    return this.post('user/profile/updateAcceptedDpp', { value })
  }
}

export default new UserApi()
